"use strict";

/* jshint -W098 */
angular.module("mean.projects").controller("TradeTasksAdminController", [
    "$scope",
    "$rootScope",
    "$q",
    "Global",
    "Projects",
    "ProjectBids",
    "MeanUser",
    "Users",
    "$filter",
    "$http",
    "Holidays",
    "$timeout",
    "ProjectTasks",
    "taskFilterService",
    "daysDifferenceService",
    "taskRescheduleService",
    "taskService",
    "tradeCodeService",
    "taskListService",
    "userService",
    "aceUtils",
    "ngDialog",
    "toaster",
    "Extras",
    "Trades",
    function (
        $scope,
        $rootScope,
        $q,
        Global,
        Projects,
        ProjectBids,
        MeanUser,
        Users,
        $filter,
        $http,
        Holidays,
        $timeout,
        ProjectTasks,
        taskFilterService,
        daysDifferenceService,
        taskRescheduleService,
        taskService,
        tradeCodeService,
        taskListService,
        userService,
        aceUtils,
        ngDialog,
        toaster,
        Extras,
        Trades
    ) {
        $scope.global = Global;
        $scope.package = {
            name: "projectTasksAdmin",
        };

        console.log("projectTasksAdmin");

        $scope.mode = "day";

        $scope.status_codes = [
            "on_track",
            "delayed_start",
            "work_stoppage",
            "finished",
        ];

        $scope.date_array = [];

        $scope.sortType = ["phase", "lot", "days_offset"];
        $scope.sortReverse = false;

        $scope.tasks = [];
        $scope.projects = [];
        $scope.foreman_users = [];
        $scope.tradesman_users = [];
        $scope.my_roles = [];
        $scope.is_admin = false;
        $scope.is_builder = false;
        $scope.is_division = false;
        $scope.is_manager = false;
        $scope.selectedPhase = {};
        $scope.selectedLot = {};
        $scope.selectedTask = {};
        $scope.selectedTrade = {};

        $scope.extra = {
            hours: 0,
            rate: 0,
            labor: 0,
            material: 0,
            equipment: 0,
            total: 0,
        };

        $scope.minDate = new Date();
        $scope.dateOptions = {
            dateDisabled: disabled,
            formatYear: "yy",
            //minDate: new Date(),
            maxDate: new Date(2030, 1, 20),
            showWeeks: false,
            startingDay: 0,
        };

        $scope.user = MeanUser.user;
        $scope.my_roles = MeanUser.user.roles;

        daysDifferenceService.setHolidaysArray($scope.user.username);

        // $scope.current_trades = tradeCodeService.getArray();

        // $scope.current_trades.unshift({
        //     name: 'All'
        // });

        $scope.formatString = "yyyy-MM-ddTHH:mm";

        $scope.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened = true;
        };

        $scope.openEnd = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.endOpened = true;
        };

        $scope.editOpen = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $timeout(function () {
                $scope.editOpened = true;
            }, 50);
        };

        function disabled(data) {
            return daysDifferenceService.disabled(data.date, data.mode);
        }

        $scope.init = function () {
            $scope.is_admin = userService.isAdmin($scope.user);
            //userService.getMainAccountId($scope.user.username).then(function(id) {
            if ($scope.is_admin) {
                //this will get the trade company's project but
                //we need to get the builders projects we're attached to
                Projects.query(
                    {
                        trade_code: tradeCodeService.getCode(
                            $scope.user.trade[0]
                        ),
                        complete: false,
                        company_code: $scope.user.contractor_code,
                    },
                    function (projects) {
                        $scope.projects = projects;
                        userService
                            .getMainAccount($scope.user.username)
                            .then(function (user) {
                                Projects.query(
                                    {
                                        trade_code: "00",
                                        complete: false,
                                        "trades.main_username": user.username,
                                    },
                                    function (projects) {
                                        for (
                                            var i = 0;
                                            i < projects.length;
                                            i++
                                        )
                                            $scope.projects.push(projects[i]);
                                    }
                                );

                                Trades.query(
                                    { main_account_id: user._id },
                                    function (trade) {
                                        if (trade.length === 0) return;

                                        trade[0].company_code =
                                            aceUtils.padDigits(
                                                trade[0].company_code,
                                                3
                                            );
                                        trade[0].trade_code =
                                            tradeCodeService.getCode(
                                                trade[0].trade
                                            );
                                        $scope.my_trade = trade[0];
                                    }
                                );
                            });
                    }
                );
            } else {
                Projects.query(
                    {
                        complete: false,
                        "trades.manager.username": $scope.user.username,
                    },
                    function (projects) {
                        $scope.projects = projects;
                    }
                );

                userService
                    .getMainAccount($scope.user.username)
                    .then(function (user) {
                        Trades.query(
                            { main_account_id: user._id },
                            function (trade) {
                                if (trade.length === 0) return;

                                trade[0].company_code = aceUtils.padDigits(
                                    trade[0].company_code,
                                    3
                                );
                                trade[0].trade_code = tradeCodeService.getCode(
                                    trade[0].trade
                                );
                                $scope.my_trade = trade[0];
                            }
                        );
                    });
            }

            taskListService.get().then(function (result) {
                if ($scope.is_admin) {
                    $scope.current_tasks = result;
                } else {
                    $scope.current_tasks = $filter("filter")(
                        result,
                        {
                            trade: tradeCodeService.getCode(
                                $scope.user.trade[0]
                            ),
                        },
                        true
                    );
                }

                $scope.current_tasks.unshift({
                    order: -1,
                    task_name: "All",
                    name: "All",
                    trade: tradeCodeService.getArrayCodes(),
                });
            });

            if ($scope.is_admin) {
                Users.query(
                    {
                        roles: "foreman",
                        contractor_code: $scope.user.contractor_code,
                        trade: $scope.user.trade[0],
                    },
                    function (users) {
                        $scope.foreman_users = $filter("filter")(users, {
                            roles: "foreman",
                        });
                    }
                );
            } else {
                Users.query(
                    {
                        roles: "foreman",
                        contractor_code: $scope.user.contractor_code,
                        trade: $scope.user.trade[0],
                    },
                    function (users) {
                        $scope.foreman_users = $filter("filter")(users, {
                            roles: "foreman",
                            trade: MeanUser.user.trade[0],
                        });
                    }
                );
            }
        };

        $scope.changeProject = function () {
            $scope.tasks = [];
            $scope.current_trades = [];
            $scope.formatString =
                $scope.formatString + $scope.selectedItem.contact.timezone;

            $scope.current_trades = tradeCodeService.getArray();

            // $scope.current_trades.unshift({
            //     name: 'All'
            // });

            Extras.query(
                {
                    project_id: $scope.selectedItem._id,
                    trade_id: $scope.my_trade._id,
                    complete: false,
                    trade: $scope.user.trade[0],
                },
                function (extras) {
                    $scope.extras = extras;
                    $scope.nextAWANumber();
                }
            );

            $scope.selectedPhase = {};
            $scope.selectedLot = {};
            $scope.selectedTask = {};

            $scope.selectedTrade = {};

            $scope.updatePhaseList();
            $scope.changePhase();
            //$scope.changeTrade();
        };

        $scope.changePhase = function (selectedPhase) {
            if (!aceUtils.isUndefinedOrNull(selectedPhase))
                $scope.selectedPhase = selectedPhase;

            $scope.tasks = [];
            $scope.lots = [];
            var lots = [];

            if (selectedPhase)
                lots = $filter("filter")(
                    $scope.selectedItem.lots,
                    { phase: selectedPhase.name },
                    true
                );
            else lots = $scope.selectedItem.lots;

            lots.forEach(function (lot) {
                var inlist = $filter("filter")(
                    $scope.lots,
                    { name: lot.number },
                    true
                );

                if (inlist.length === 0) {
                    $scope.lots.push({
                        name: lot.number,
                    });
                }
            });

            // $scope.lots.unshift({
            //     name: 'All'
            // });

            $scope.selectedLot = {};
        };

        $scope.changeLot = function (selectedLot) {
            $scope.selectedLot = selectedLot;
            $scope.tasks = [];
        };

        $scope.changeTrade = function (selectedTrade) {
            // if(aceUtils.isUndefinedOrNull(selectedTrade)) {
            //     $scope.selectedTrade = $scope.current_trades[0];
            // } else {
            //     $scope.selectedTrade = selectedTrade;
            // }
            $scope.selectedTrade = selectedTrade ? selectedTrade : {};
            $scope.tasks = [];
        };

        $scope.changeTask = function (selectedTask) {
            if (!aceUtils.isUndefinedOrNull(selectedTask))
                $scope.selectedTask.name = selectedTask.task_code;
            else $scope.selectedTask = $scope.current_tasks[0];

            $scope.tasks = [];
        };

        $scope.updatePhaseList = function () {
            $scope.current_phases = [];

            $scope.selectedItem.lots = _.remove(
                $scope.selectedItem.lots,
                function (lot) {
                    return !lot.complete;
                }
            );

            $scope.selectedItem.lots.forEach(function (lot) {
                var inlist = $filter("filter")(
                    $scope.current_phases,
                    { name: lot.phase },
                    true
                );

                if (inlist.length === 0) {
                    $scope.current_phases.push({
                        name: lot.phase,
                    });
                }
            });

            //$scope.selectedPhase = $scope.current_phases[0];
        };

        $scope.getFilteredTasks = function () {
            $scope.guiRecordItem = $scope.selectedItem.name;
            var trade = ($scope.guiRecordTrade = $scope.selectedTrade.name);
            var task = ($scope.guiRecordTask =
                $scope.selectedTask && $scope.selectedTask.name
                    ? $scope.selectedTask.name
                    : "All");
            var phase = ($scope.guiRecordPhase =
                $scope.selectedPhase && $scope.selectedPhase.name
                    ? $scope.selectedPhase.name
                    : "All");
            var lot = ($scope.guiRecordLot =
                $scope.selectedLot && $scope.selectedLot.name
                    ? $scope.selectedLot.name
                    : "All");

            if ($scope.is_admin) {
                if (task !== "All") {
                    if (lot !== "All") {
                        var q_call = ProjectTasks.query(
                            {
                                project_id: $scope.selectedItem._id,
                                complete: false,
                                trade: $scope.selectedTrade.name,
                                lot: $scope.selectedLot.name,
                                task_code: $scope.selectedTask.name,
                            },
                            function (tasks) {}
                        );
                    } else if (phase !== "All") {
                        var q_call = ProjectTasks.query(
                            {
                                project_id: $scope.selectedItem._id,
                                complete: false,
                                trade: $scope.selectedTrade.name,
                                phase: $scope.selectedPhase.name,
                                task_code: $scope.selectedTask.name,
                            },
                            function (tasks) {}
                        );
                    } else if (trade !== "All") {
                        var q_call = ProjectTasks.query(
                            {
                                project_id: $scope.selectedItem._id,
                                complete: false,
                                trade: $scope.selectedTrade.name,
                                task_code: $scope.selectedTask.name,
                            },
                            function (tasks) {}
                        );
                    } else {
                        var q_call = ProjectTasks.query(
                            {
                                project_id: $scope.selectedItem._id,
                                complete: false,
                                task_code: $scope.selectedTask.name,
                            },
                            function (tasks) {}
                        );
                    }
                } else if (trade !== "All") {
                    if (lot !== "All") {
                        var q_call = ProjectTasks.query(
                            {
                                project_id: $scope.selectedItem._id,
                                complete: false,
                                trade: $scope.selectedTrade.name,
                                lot: $scope.selectedLot.name,
                            },
                            function (tasks) {}
                        );
                    } else if (phase !== "All") {
                        var q_call = ProjectTasks.query(
                            {
                                project_id: $scope.selectedItem._id,
                                complete: false,
                                trade: $scope.selectedTrade.name,
                                phase: $scope.selectedPhase.name,
                            },
                            function (tasks) {}
                        );
                    } else {
                        var q_call = ProjectTasks.query(
                            {
                                project_id: $scope.selectedItem._id,
                                complete: false,
                                trade: $scope.selectedTrade.name,
                            },
                            function (tasks) {}
                        );
                    }
                } else if (lot !== "All") {
                    var q_call = ProjectTasks.query(
                        {
                            project_id: $scope.selectedItem._id,
                            lot: $scope.selectedLot.name,
                        },
                        function (tasks) {}
                    );
                } else if (phase !== "All") {
                    var q_call = ProjectTasks.query(
                        {
                            project_id: $scope.selectedItem._id,
                            complete: false,
                            phase: $scope.selectedPhase.name,
                        },
                        function (tasks) {}
                    );
                } else {
                    var q_call = ProjectTasks.query(
                        {
                            complete: false,
                            project_id: $scope.selectedItem._id,
                        },
                        function (tasks) {}
                    );
                }
            } else {
                if (task !== "All") {
                    if (lot !== "All") {
                        var q_call = ProjectTasks.query(
                            {
                                project_id: $scope.selectedItem._id,
                                complete: false,
                                trade_manager_id: MeanUser.user._id,
                                lot: $scope.selectedLot.name,
                                task_code: $scope.selectedTask.name,
                            },
                            function (tasks) {}
                        );
                    } else if (phase !== "All") {
                        var q_call = ProjectTasks.query(
                            {
                                project_id: $scope.selectedItem._id,
                                complete: false,
                                trade_manager_id: MeanUser.user._id,
                                phase: $scope.selectedPhase.name,
                                task_code: $scope.selectedTask.name,
                            },
                            function (tasks) {}
                        );
                    } else {
                        var q_call = ProjectTasks.query(
                            {
                                project_id: $scope.selectedItem._id,
                                complete: false,
                                trade_manager_id: MeanUser.user._id,
                                task_code: $scope.selectedTask.name,
                            },
                            function (tasks) {}
                        );
                    }
                } else if (lot !== "All") {
                    var q_call = ProjectTasks.query(
                        {
                            project_id: $scope.selectedItem._id,
                            complete: false,
                            trade_manager_id: MeanUser.user._id,
                            lot: $scope.selectedLot.name,
                        },
                        function (tasks) {}
                    );
                } else if (phase !== "All") {
                    var q_call = ProjectTasks.query(
                        {
                            project_id: $scope.selectedItem._id,
                            complete: false,
                            trade_manager_id: MeanUser.user._id,
                            phase: $scope.selectedPhase.name,
                        },
                        function (tasks) {}
                    );
                } else {
                    var q_call = ProjectTasks.query(
                        {
                            project_id: $scope.selectedItem._id,
                            complete: false,
                            trade_manager_id: MeanUser.user._id,
                        },
                        function (tasks) {}
                    );
                }
            }

            q_call.$promise.then(function (result) {
                $scope.tasks = result;
            });
        };

        $scope.updateForeman = function (task, selectedUser) {
            if (!$scope.selectedItem) {
                alert("Project not selected");
                return;
            }

            if (task.trade !== selectedUser.trade[0]) {
                alert(
                    "Selected user " +
                        selectedUser.name +
                        " is not a valid selection due to trade."
                );
                return;
            }

            task.foreman = {
                name: selectedUser.name,
                username: selectedUser.username,
                phone: selectedUser.phone,
                email: selectedUser.email,
            };

            task.notes.push({
                date: new Date(),
                comment: "Foreman changed to " + selectedUser.name,
                username: $scope.user.username,
            });

            task.$update();
        };

        $scope.updateForemanAllTasks = function (selectedUser) {
            if (!$scope.selectedItem) {
                alert("Project not selected");
                return;
            }

            var tasks = [];

            if ($scope.selectedTrade.name === "All")
                delete $scope.selectedTrade;
            if ($scope.selectedPhase.name === "All")
                delete $scope.selectedPhase;
            if ($scope.selectedLot.name === "All") delete $scope.selectedLot;
            if ($scope.selectedTask.name === "All") delete $scope.selectedTask;

            tasks = taskFilterService.getList(
                $scope.tasks,
                $scope.selectedTrade,
                $scope.selectedPhase,
                $scope.selectedLot,
                $scope.selectedTask
            );

            tasks.forEach(function (task) {
                if (task.trade === selectedUser.trade[0]) {
                    task.foreman = {
                        name: selectedUser.name,
                        username: selectedUser.username,
                        phone: selectedUser.phone,
                        email: selectedUser.email,
                    };

                    task.notes.push({
                        date: new Date(),
                        comment: "Foreman changed to " + selectedUser.name,
                        username: $scope.user.username,
                    });

                    task.$update();
                }
            });

            this.selectedForeman = "";
        };

        $scope.updateStatus = function (task, status) {
            task.status = status;

            if (status === "work_stoppage" || status === "delayed_start") {
                task.hot_sheet = true;
            }

            task.notes.push({
                date: new Date(),
                comment: "Status changed to " + status,
                username: $scope.user.username,
            });

            task.$update();
        };

        $scope.update = function (task) {
            task.$update();
        };

        $scope.extraUpdate = function () {
            this.extra.labor = $filter("number")(
                this.extra.hours * this.extra.rate,
                2
            );
            this.extra.total = $filter("number")(
                this.extra.labor * 1 +
                    this.extra.material * 1 +
                    this.extra.equipment * 1,
                2
            );
        };

        $scope.nextAWANumber = function () {
            //$scope.extras has the most current list
            if ($scope.extras.length > 0) {
                var unique_numbers = $filter("unique")(
                    $scope.extras,
                    "awa_number"
                );
                var numbers = $filter("orderBy")(unique_numbers, [
                    "awa_number",
                ]);
                $scope.next_awa_number =
                    numbers[numbers.length - 1].awa_number + 1;
            } else {
                $scope.next_awa_number = 1;
            }
        };

        $scope.addExtras = function () {
            console.log("adding extras");
            var checked = $filter("filter")($scope.tasks, { checked: true });

            if (checked.length === 0) {
                toaster.pop("error", "Task Selection", "No tasks selected.");
                return;
            }

            var unique = $filter("unique")(checked, "trade");

            if (unique.length > 1) {
                toaster.pop(
                    "error",
                    "Task Selection",
                    "Multiple trades cannot be selected"
                );
                return;
            }

            var my_trade = $filter("filter")(
                unique,
                {
                    trade: $scope.user.trade[0],
                },
                true
            );

            if (my_trade.length !== 1) {
                toaster.pop(
                    "error",
                    "Task Selection",
                    "Only user trade tasks can be selected"
                );
                return;
            }

            var hours = this.extra.hours / checked.length;
            var labor = this.extra.labor / checked.length;
            var material = this.extra.material / checked.length;
            var equipment = this.extra.equipment / checked.length;
            var total = this.extra.total / checked.length;
            var rate = this.extra.rate;
            var note = this.extra.note;
            var date = new Date();

            var total_saved = 0;

            _.each(checked, function (task) {
                var extra = new Extras({
                    project_id: $scope.selectedItem._id,
                    project_task_id: task._id,
                    trade_id: $scope.my_trade._id,
                    trade: $scope.my_trade.trade,
                    phase: task.phase,
                    lot: task.lot,
                    task: task.task_code,
                    awa_number: $scope.next_awa_number,
                    hours: hours,
                    rate: rate,
                    labor: labor,
                    material: material,
                    equipment: equipment,
                    total: total,
                    status: "Open",
                    date: date,
                    note: note,
                });

                total_saved += 1;

                extra.$save(
                    function (success) {
                        //toaster.pop('success', 'Extra Created');
                    },
                    function (error) {
                        toaster.pop("error", "Save Extras Error", error);
                    }
                );
            });

            if (total_saved === checked.length) {
                $scope.next_awa_number += 1;
                _.each(checked, function (task) {
                    task.checked = false;
                });

                toaster.pop("success", "Extras Saved", "Database updated.");

                this.extra.labor = this.extra.hours = this.extra.rate = 0;
                this.extra.total =
                    this.extra.material =
                    this.extra.equipment =
                        0;
                this.extra.note = "";
            }
        };

        $scope.editTasks = function () {
            var checked = $filter("filter")($scope.tasks, { checked: true });
            if ($scope.selectionOption === "status") {
                if ($scope.reopen_selected === "Open") {
                    checked.forEach(function (task) {
                        task.status = "on_track";
                        task.date_completed = "";
                        var note = {
                            date: new Date(),
                            comment:
                                "Changed the status to on_track to reopen this task",
                            username: $scope.user.username,
                        };

                        task.notes.push(note);
                        task.$update();
                    });
                } else {
                    checked.forEach(function (task) {
                        task.status = "finished";
                        task.date_completed = new Date();
                        var note = {
                            date: new Date(),
                            comment:
                                "Changed the status to finished to close this task",
                            username: $scope.user.username,
                        };

                        task.notes.push(note);
                        task.$update();
                    });
                }
            } else {
                if (!$scope.entire_schedule || !$scope.change_reason) {
                    alert(
                        "You must select a Reason option and Entire Schedule option."
                    );
                    return;
                }
                if (checked.length === 0) {
                    alert("At least one task has to be selected for changes.");
                    return;
                }

                var tasks_to_update = [];
                //var q_call = Promise.resolve();

                if ($scope.entire_schedule === "No") {
                    taskRescheduleService.scheduleNoPush(
                        $scope.user,
                        checked,
                        $scope.new_start_date,
                        $scope.new_end_date,
                        $scope.change_reason
                    );
                } else {
                    //if we are doing the entire schedule then
                    //we need to make sure only one task per lot
                    //is select or things can get out of whack.
                    var items = [];
                    _.each(checked, function (check) {
                        var inlist = $filter("filter")(
                            items,
                            { lot: check.lot },
                            true
                        );
                        if (inlist.length === 0) {
                            items.push(check);
                        } else {
                            alert(
                                "Multiple tasks for the same lot have been selected. \nPlease select one task from a given lot to reschedule the entire task list"
                            );
                            return;
                        }
                    });

                    taskRescheduleService.schedulePush(
                        $scope.user,
                        items,
                        $scope.new_start_date,
                        $scope.new_end_date,
                        $scope.change_reason
                    );
                }

                $rootScope.$on(
                    "RescheduleEventComplete",
                    function (event, data) {
                        console.log("RescheduleEventComplete");
                        data.forEach(function (task) {
                            var update_view = $filter("filter")(
                                $scope.tasks,
                                { _id: task._id },
                                true
                            )[0];
                            if (!aceUtils.isUndefinedOrNull(update_view)) {
                                update_view.start_date = task.start_date;
                                update_view.end_date = new Date(task.end_date);
                                update_view.days = task.days;
                                update_view.status = task.status;
                                update_view.days_offset = task.days_offset;
                                update_view.checked = false;
                            }
                        });

                        toaster.pop("success", "Tasks Rescheduled");
                    }
                );
            }
        };

        // This was added just to play around a bit
        // taskService.getByTrade($scope.user.trade[0]).then(function (response) {
        //         $scope.returned_tasks = response;
        //     }, function (error) {
        //         console.error(error);
        // });

        // $scope.clickToUpdate = function(task) {
        //     taskService.update(task).then(function(response) {
        //         task = response;
        //     }, function(error) {
        //         console.error(error);
        //     });
        // };

        $scope.startDateChanged = function (new_start_date) {
            var date = moment(new_start_date)
                .add(8, "hours")
                .add(30, "minutes");
            $scope.new_end_date = new Date(date);
        };

        $scope.taskChecked = function (task) {
            if (task.checked) {
                var start = moment(task.start_date);
                var end = moment(task.end_date);

                $scope.new_start_date = new Date(start);
                $scope.new_end_date = new Date(end);
            } else {
                $scope.new_start_date = "";
                $scope.new_end_date = "";
            }
        };

        $scope.updateForemanOperation = function (foreman) {
            $scope.selectedForeman = foreman;
            ngDialog
                .openConfirm({
                    template:
                        "<h2>Change Foreman Confirm</h2>" +
                        "<p>This will operation will change the Foreman for all selected tasks</p>" +
                        "<p>Are you sure you wish to continue? </p>" +
                        "<div>" +
                        '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;</button>' +
                        '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                        "</button></div>",
                    plain: true,
                    scope: $scope,
                    className: "ngdialog-theme-default",
                })
                .then(
                    function (value) {
                        $scope.updateForemanAllTasks($scope.selectedForeman);
                    },
                    function (value) {
                        //Do something
                        //console.log('in the do something section');
                    }
                );
        };
    },
]);



// WEBPACK FOOTER //
// ./packages/custom/trades/public/controllers/tradeTasksAdmin.js